"use client";

import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";
import type { UserPreferences } from "@/lib/types";

/**
 * The time zone the SERVER reads a picked deadline in: the signed-in user's
 * stored account zone, or "UTC" when none is stored (backend `deadlines.py`).
 * The browser's zone is not used — the two can differ (a stored "UTC", travel),
 * and a hint that says "your time" would then be false.
 *
 * One fetch per page load, shared with `usePersistTimeZone` via `rememberAccountTimeZone`.
 */
let cached: Promise<string | null> | null = null;

export function rememberAccountTimeZone(tz: string | null) {
  cached = Promise.resolve(tz);
}

export function useAccountTimeZone(getAccessToken: () => string | null): string | null {
  const [tz, setTz] = useState<string | null>(null);
  useEffect(() => {
    const token = getAccessToken();
    if (!token) return;
    if (!cached) {
      cached = apiFetch<UserPreferences>("/auth/me/preferences", { token })
        .then((p) => p.timezone || "UTC")
        .catch(() => { cached = null; return null; });
    }
    let live = true;
    cached.then((v) => { if (live) setTz(v); });
    return () => { live = false; };
  }, [getAccessToken]);
  return tz;
}
